import api from './api-init';

const {
    baseApi,
    del,
    feApi,
    get,
    patch,
    post,
    publicDel,
    publicGet,
    publicPatch,
    publicPost,
    publicPut,
    put
} = api;

export {
    baseApi,
    del,
    feApi,
    get,
    patch,
    post,
    publicDel,
    publicGet,
    publicPatch,
    publicPost,
    publicPut,
    put
};
